export default __webpack_public_path__ + "static/media/m4dz.6142a580.png";